module.exports = __webpack_public_path__ + "img/red.e497c318.png";